module.exports = __webpack_public_path__ + "img/obotAvatar.585b9df2.png";